import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { HttpTimeoutError } from '@cian/peperrors/shared';
import {
  fetchApiGeoGeocodedForSearch,
  IApiGeoGeocodedForSearchRequest,
  IApiGeoGeocodedForSearchResponse,
  IApiGeoGeocodedForSearchResponse200,
  IApiGeoGeocodedForSearchResponse400,
  IApiGeoGeocodedForSearchResponseError,
} from '../repositories/monolith-cian-realty/unversioned/api-geo-geocoded-for-search';

import { isResponseContainsKey } from './helpers';

export async function getGeocodedSearchData(
  httpApi: IHttpApi,
  parameters: IApiGeoGeocodedForSearchRequest,
  logger: ILogger,
  subdomain?: string,
) {
  try {
    const { response } = await fetchApiGeoGeocodedForSearch<
      IApiGeoGeocodedForSearchResponse200,
      IApiGeoGeocodedForSearchResponse400
    >({
      httpApi,
      parameters,
      config: {
        bodyAsEncodeString: true,
        ecnhancersConfig: {
          timeout: 5000,
        },
        requestConfig: {
          headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        },
        subdomain: subdomain || 'www',
      },
    });

    if (
      isResponseContainsKey<IApiGeoGeocodedForSearchResponseError, IApiGeoGeocodedForSearchResponse>(response, 'errors')
    ) {
      throw response;
    }

    return response;
  } catch (error) {
    let message;
    if (HttpTimeoutError.is(error)) {
      message = 'TimeoutError in getGeocodedSearchData';
    } else {
      message = 'Error in getGeocodedSearchData';
    }
    logger.error(error, { message });

    return {
      geo: {
        lat: parameters.lat,
        lng: parameters.lng,
      },
      geoLocationCatalogLink: null,
      text: parameters.address,
      isParsed: true,
    };
  }
}
